'use strict'
import axios from 'axios'
// import store from '@/store'
// import router from '@/router'
import bus from './bus.js'
// import { getToken, getTenant } from '@/utils/auth'
// import { sysAppId, isLocal } from '@/settings.js'

// import qs from 'qs'
// const {API_ROOT} = require('../../static/config.js')
// const config = require('../../static/config.js')
// const API_ROOT = (window.top.window.g && window.top.window.g.CHAT_API_ROOT) ? window.top.window.g.CHAT_API_ROOT : window.httpConfig.API_ROOT
let API_APPLET_ROOT = window.httpConfig.API_APPLET_ROOT

const server = axios.create({
  baseURL: API_APPLET_ROOT
})

server.interceptors.request.use(
  config => {
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    // =========================================================
    // 请求拦截
    // const isToken = (config.headers || {}).isToken === false
    /*  if (whiteList.indexOf(config.url) > -1) {
      let token = localStorage.getItem('YT_accessToken')
      config.headers['Authorization'] = 'Bearer ' + token
      config.headers['sysappid'] = '23021984-5501-4870-8ba6-1a48a2ef0d17'
    } else {
      let token = localStorage.getItem('token')
      config.headers['Authorization'] = 'Bearer ' + token
    } */
    /* if (config.headers['Content-Type'] !== 'application/x-www-form-urlencoded') {
      if (config.method === 'post' || config.method === 'POST') {
        config.data = qs.stringify(config.data)
      }
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    } */
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

server.interceptors.response.use(
  response => {
    // 响应拦截
    return response
  },
  error => {
    return Promise.resolve(error.response)
  }
)

// eslint-disable-next-line no-unused-vars
function checkStatus (response) {
  // 处理响应数据
  if (response && (response.status === 200 || response.status === 204)) {
    // loading,如果http状态码正常，则直接返回数据
    let res = response.data
    if (!res) {
      bus.$message.error('服务器开了个小差')
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(false)
    }
    if (res.statusCode === 200 || res.statusCode === 204 || res.code === 200) {
      return res.data
    } else if (res.code === 10000) {
      return res.content
    } else {
      if (res.errors && res.errors !== '群组Id错误') {
        bus.$message.error(res.errors)
      }
      if (res.message) {
        bus.$message.error(res.message)
      }
      return Promise.reject(res)
    }
  } else {
    if (response.data.error && !response.data.error.code) {
      bus.$message.error(response.data.error.message)
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(false)
    } else {
      return Promise.reject(response.data)
    }
  }
}

function checkCode (_error) {
  bus.$message.error('网络异常~')
}

export default {
  postApplet (url, data, query) {
    const options = {
      method: 'post',
      url: url,
      timeout: 10000,
      data: data
    }
    return server(options)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  },
  getApplet (url, data, query) {
    const options = {
      method: 'get',
      url: url,
      timeout: 10000,
      transformRequest: [function (data, headers) {
        // 去除post请求默认的Content-Type
        delete headers.post['Content-Type']
        return data
      }],
      params: data
    }
    return server(options)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  },
  putApplet (url, data, query, queryAndBody) {
    const options = {
      method: 'put',
      url: url,
      timeout: 10000,
      data: data
    }
    return server(options)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  },
  deleteApplet (url, data) {
    const options = {
      method: 'delete',
      url: url,
      timeout: 10000,
      data: data
    }
    return server(options)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  }
}



// WEBPACK FOOTER //
// ./packages/api/httpApplet.js